import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, NavParams, Platform } from '@ionic/angular';
import { Estacao } from 'src/app/shared/models/estacao.model';
import { EstacaoService } from 'src/app/shared/services/estacao.service';

@Component({
  selector: 'app-estacao-fonte',
  templateUrl: './estacao-fonte.component.html',
  styleUrls: ['./estacao-fonte.component.scss'],
})
export class EstacaoFonteComponent implements OnInit {
  estacao: Estacao;
  private prefixoRota: string;
  private isDesktop: boolean;
  isHybrid = false;

  constructor(
    private navParams: NavParams,
    private platform: Platform,
    private router: Router,
    private estacaoService: EstacaoService,
    private modalCtrl: ModalController) { }

  ngOnInit() {
    this.isDesktop = this.platform.is('desktop') &&
      !this.platform.is('mobile') &&
      !this.platform.is('mobileweb');
    this.prefixoRota = this.isDesktop ? '' : '/tabs';
    this.isHybrid = this.platform.is('hybrid');
    this.estacao = this.navParams.data.estacao;
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

}
